import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import dataV from '@jiaminghi/data-view'
import * as echarts from 'echarts';
import router from './router';
import moment from 'moment'
import { loadDevApiConfig, isDev } from './config/config';

console.log('当前环境:', process.env.NODE_ENV);
console.log('是否为开发环境:', isDev());

Vue.prototype.$moment = moment;
Vue.prototype.$echarts = echarts;
Vue.use(dataV)
Vue.config.productionTip = false
Vue.use(ElementUI);

console.log('调用 loadDevApiConfig 前');
loadDevApiConfig();
console.log('调用 loadDevApiConfig 后');

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
